module.exports = __webpack_public_path__ + "img/save-plain-icon.c77cb24c.svg";